import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import InputField from 'components/InputField/InputField';
import PasswordField from 'components/InputField/PasswordField';

const labels = {
  email: 'Email',
  password: 'Password',
}

const LoginForm = ({
    email,
    password,
    passwordType,
    onFieldChange,
    onSubmit,
    onPasswordTypeToggle
  }) => (
    <div className="container_global_signin">
      <h2 className="signin_title">WELCOME TO MEDCAFE</h2> <div className="container_signin row">
        <form className="col s12" onSubmit={onSubmit}>
          <div className="row">
            <InputField
              label={labels['email']}
              onChange={onFieldChange}
              field_name='email'
              value={email}
              type='email'
              className='col s12'
             />
            <PasswordField
              label={labels['password']}
              onChange={onFieldChange}
              field_name='password'
              value={password}
              showPassword={passwordType == 'text'}
              onPasswordChangeVisibility={onPasswordTypeToggle}
              autoComplete='current-password'
              className='col s12'
             />
            <Link to='/users/forgot_password' className="forgot col s6" style={{float: 'right'}}>
              Forgot password?
            </Link>
            <div className="submit_center col s12">
              <input className="container_signin_button" type="submit" name="" value="Sign In" />
            </div>
          </div>
        </form>
        <p className="container_signin_text" style={{ marginBottom: '15px' }}>
          <Link to="/users/sign_up">
            Don’t have an account?
          </Link>
        </p>
      </div>
    </div>
)

LoginForm.propTypes = {
  email: PropTypes.string,
  password: PropTypes.string,
  passwordType: PropTypes.string,
  onFieldChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onPasswordTypeChange: PropTypes.func,
}

export default LoginForm



/** WEBPACK FOOTER **
 ** ./src/components/Authorization/Login/LoginForm.js
 **/